module.exports = __webpack_public_path__ + "static/media/27.f4b7312a.jpg";